import { HttpClient } from '@angular/common/http';
import {  Inject, Injectable } from '@angular/core';
import { AbstractAppConfigService, APP_CONFIG_SERVICE } from '@boxx/core/lib/contracts/IAppConfigService';
import { JsonApiResponse } from '@boxx/core/lib/contracts/IHttpBasicResponse';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NFCService  {
  constructor(
    @Inject(APP_CONFIG_SERVICE) private appSettings: AbstractAppConfigService,
    private httpClient: HttpClient
  ) {}

  activateNFC(payload: any): Observable<JsonApiResponse<any>> {
    const urlSearchParams = new URLSearchParams();

    Object.keys(payload).forEach((key: string) => {
      urlSearchParams.append(key, payload[key]);
    });

    const body = urlSearchParams.toString();

    return this.httpClient.post<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/NFCDevices/activate`,
      body
    );
  }

  updateNFC(payload: any): Observable<JsonApiResponse<any>> {
    const urlSearchParams = new URLSearchParams();

    Object.keys(payload).forEach((key: string) => {
      urlSearchParams.append(key, payload[key]);
    });

    const body = urlSearchParams.toString();

    return this.httpClient.post<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/NFCDevices/update/` + payload.code,
      body
    );
  }

  updateportalClickLinks(payload: any): Observable<JsonApiResponse<any>> {
    const urlSearchParams = new URLSearchParams();

    Object.keys(payload).forEach((key: string) => {
      urlSearchParams.append(key, payload[key]);
    });

    const body = urlSearchParams.toString();

    return this.httpClient.post<JsonApiResponse<any>>(
      `${this.getJsonBaseUrl()}/PortalClick/update_configuration`,
      body
    );
  }

  getNFCDevices(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.getJsonBaseUrl()}/NFCDevices/list`,
    );
  }

  getPortalClick(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.getJsonBaseUrl()}/PortalClick/get`,
    );
  }

  getPortalClickLinks(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.getJsonBaseUrl()}/PortalClick/get_configuration`,
    );
  }

  private getJsonBaseUrl() {
    return `${this.appSettings.baseUrl()}/api/json/v1`;
  }

}